// extracted by mini-css-extract-plugin
export default {"container":"kanjiSuggestion_container__5LTUh","label":"kanjiSuggestion_label__tROBd","kanji":"kanjiSuggestion_kanji__AY3iC","cancel":"kanjiSuggestion_cancel__DTelY"};